<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: isRequired }">
  {{ label }}
</label>
<div class="control-wrapper">
  <div>
    <div>
      <input
        class="mr-05"
        type="text"
        pInputText
        (change)="selectValue($event)"
        [value]="selectedValue"
        [disabled]="control.disabled || forceDisable" />
      <ng-content select="app-suffix"></ng-content>
    </div>
    <app-errors [errors]="errors" [showErrors]="!control.pristine && !control.disabled"></app-errors>
  </div>
</div>
